import { useState } from 'react';
import styled from 'styled-components';
import {
  Loading,
  Flex,
  FlexColumn,
  Breadcrumbs,
  Button,
  Table,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { useTokens } from './useTokens';
import { useTokensColumns } from './useTokensColumns';
import GenerateTokenDialog from './GenerateTokenDialog';
import { TokenConfig } from './types';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: 24px;
`;

const Frame = styled(FlexColumn)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray8};
  border-radius: 6px;
  padding: 32px;
  gap: 24px;
`;

type Props = {
  config: TokenConfig;
  breadcrumbs: string[];
  pageTitle: string;
  urlParamsPrefix: string;
};

const TokensPage = ({
  config,
  breadcrumbs,
  pageTitle,
  urlParamsPrefix,
}: Props) => {
  const [isGenerateDialogOpen, setIsGenerateDialogOpen] = useState(false);

  const {
    tokens,
    isLoading,
    createToken,
    isCreating,
    deleteToken,
    isDeleting,
  } = useTokens(config);
  const columns = useTokensColumns(deleteToken, isDeleting, config.tokenType);

  return isLoading ? (
    <Loading />
  ) : (
    <Wrapper>
      <Breadcrumbs items={breadcrumbs} showTreeButton={false} />

      <Frame>
        <Flex
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ fontWeight: 'bold' }}>{pageTitle}</Typography>
          <Button onClick={() => setIsGenerateDialogOpen(true)}>
            Generate token
          </Button>
        </Flex>

        <Table
          data={tokens?.accessTokens || []}
          columns={columns}
          isLoading={isLoading}
          urlParamsPrefix={urlParamsPrefix}
        />

        <GenerateTokenDialog
          isOpen={isGenerateDialogOpen}
          onClose={() => setIsGenerateDialogOpen(false)}
          tokenType={config.tokenType}
          onCreateToken={async (data) => {
            const result = await createToken(data);
            return { secret: result.secret };
          }}
          isCreating={isCreating}
        />
      </Frame>
    </Wrapper>
  );
};

export default TokensPage;
